/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_News_NewInputs */

const en_us2_community_news_new = /** @type {(inputs: Community_News_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const pt_br2_community_news_new = /** @type {(inputs: Community_News_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo`)
};

const es_419_community_news_new = /** @type {(inputs: Community_News_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo`)
};

const pt_pt2_community_news_new = /** @type {(inputs: Community_News_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo`)
};

const fr_fr2_community_news_new = /** @type {(inputs: Community_News_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau`)
};

const de_de2_community_news_new = /** @type {(inputs: Community_News_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

const it_it2_community_news_new = /** @type {(inputs: Community_News_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Community_News_NewInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_news_new = /** @type {((inputs?: Community_News_NewInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_News_NewInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_news_new(inputs)
	if (locale === "es-419") return es_419_community_news_new(inputs)
	if (locale === "pt-PT") return pt_pt2_community_news_new(inputs)
	if (locale === "fr-FR") return fr_fr2_community_news_new(inputs)
	if (locale === "de-DE") return de_de2_community_news_new(inputs)
	if (locale === "it-IT") return it_it2_community_news_new(inputs)
	return en_us2_community_news_new(inputs)
});
export { community_news_new as "community.news_new" }